import classNames from 'classnames';
import { Script, ScriptStrategy } from 'gatsby';
import { useRef, useEffect } from 'react';

type Props = {
    size: 'newthin' | 'mini' | 'quote';
    className?: string;
};

const Trustpilot = ({ size, className, ...rest }: Props) => {
    const ref = useRef(null as HTMLDivElement | null);

    let templateProperties: Record<string, string>;

    switch (size) {
        case 'newthin': {
            templateProperties = {
                'data-template-id': '5419b6ffb0d04a076446a9af',
                'data-style-height': '20px',
                'data-style-width': '100%',
            };
            break;
        }
        case 'mini': {
            templateProperties = {
                'data-template-id': '53aa8807dec7e10d38f59f32',
                'data-style-height': '100px',
                'data-style-width': '185px',
            };
            break;
        }
        case 'quote': {
            templateProperties = {
                'data-template-id': '54d0e1d8764ea9078c79e6ee',
                'data-style-height': '300px',
                'data-style-width': '320px',
                'data-text-color': '#333333',
                'data-quote-color': '#333333',
                'data-tags': 'FEAT',
                'data-stars': '5',
            };
        }
    }

    useEffect(() => {
        window.Trustpilot?.loadFromElement(ref.current, true);
    }, []);

    return (
        <>
            <Script
                strategy={ScriptStrategy.postHydrate}
                src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
            />
            <div
                ref={ref}
                className={classNames('trustpilot-widget', className)}
                data-businessunit-id="5192fe2c00006400052c7f0a"
                data-theme="light"
                data-locale="en-US"
                data-review-languages="en"
                data-font-family="Open Sans"
                {...templateProperties}
                {...rest}
                data-qa="trustpilot"
            >
                <a
                    href="https://www.trustpilot.com/review/ehealthmedicare.com"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Trustpilot
                </a>
            </div>
        </>
    );
};

export default Trustpilot;
